// extracted by mini-css-extract-plugin
export default {"holiday":"date_holiday__YMyxG","holidayIcon":"date_holidayIcon__hfuf1"};